/* Day One Threads: completes the per-style "From" prices.
   Shopify gives the theme only the first 250 variants of a product. A print that comes in every
   style, size and configuration has more than that, so the styles further down the list (the
   rompers, overalls, leggings and so on) are read here from the print's own price list
   (/products/<handle>?view=dot-style-prices&page=2, ...). Display only; it never touches the
   product form, picker or cart. If anything fails, the prices simply stay as the page rendered them. */
(() => {
  if (window.DotStylePrices) return;

  const cache = new Map();

  const previewParam = () => {
    const theme = window.Shopify && window.Shopify.theme;
    return theme && theme.role && theme.role !== 'main' && theme.id ? `&preview_theme_id=${theme.id}` : '';
  };

  const better = (a, b) => (b && typeof b.c === 'number' && (!a || b.c < a.c) ? b : a);

  // Lowest price per style from variant pages 2..n (page 1 is already in the page's own markup).
  const load = (url, count) => {
    if (!url || !(count > 250)) return Promise.resolve({});
    if (cache.has(url)) return cache.get(url);
    const pages = Math.ceil(count / 250);
    const requests = [];
    for (let p = 2; p <= pages; p++) {
      requests.push(
        fetch(`${url}?view=dot-style-prices&page=${p}${previewParam()}`, { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      );
    }
    const promise = Promise.all(requests).then((list) => {
      const out = {};
      list.forEach((data) => {
        if (!data || !data.styles) return;
        Object.keys(data.styles).forEach((k) => (out[k] = better(out[k], data.styles[k])));
      });
      return out;
    });
    cache.set(url, promise);
    return promise;
  };

  const readJson = (text) => {
    try {
      return JSON.parse(text || '{}') || {};
    } catch (e) {
      return {};
    }
  };

  // Print cards: fill in missing style prices and correct the card's lowest "From" price.
  const enhanceCards = (root) => {
    root.querySelectorAll('[data-dot-card][data-variants-count]').forEach((card) => {
      const count = Number(card.dataset.variantsCount);
      if (!(count > 250) || card.dataset.dotPricesDone) return;
      card.dataset.dotPricesDone = 'true';
      load(card.dataset.productUrl, count).then((extra) => {
        const prices = readJson(card.dataset.stylePrices);
        let lowest = null;
        Object.keys(prices).forEach((style) => {
          prices[style] = better(prices[style], extra[style]);
          lowest = better(lowest, prices[style]);
        });
        card.dataset.stylePrices = JSON.stringify(prices);
        const price = card.querySelector('[data-dot-price]');
        if (price && lowest && lowest.f) {
          price.dataset.defaultPrice = lowest.f;
          price.textContent = lowest.f;
        }
        card.dispatchEvent(new CustomEvent('dot:style-prices', { bubbles: true }));
      });
    });
  };

  // Homepage Shop by Style circles: add or lower the "From" price using the same lists.
  const enhanceCircles = (root) => {
    root.querySelectorAll('[data-dot-price-sources]').forEach((section) => {
      if (section.dataset.dotPricesDone) return;
      section.dataset.dotPricesDone = 'true';
      const sources = readJson(section.dataset.dotPriceSources);
      if (!Array.isArray(sources) || !sources.length) return;
      Promise.all(sources.map((s) => load(s.u, Number(s.n)))).then((maps) => {
        section.querySelectorAll('[data-style-name]').forEach((item) => {
          const known = item.dataset.fromCents ? { c: Number(item.dataset.fromCents) } : null;
          let best = known;
          maps.forEach((map) => (best = better(best, map[item.dataset.styleName])));
          if (!best || best === known || !best.f) return;
          let span = item.querySelector('.dot-styles__price');
          if (!span) {
            span = document.createElement('span');
            span.className = 'dot-styles__price';
            (item.querySelector('.dot-styles__link') || item).appendChild(span);
          }
          span.textContent = `From ${best.f}`;
        });
      });
    });
  };

  const run = (root) => {
    enhanceCards(root);
    enhanceCircles(root);
  };

  window.DotStylePrices = { load, run };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document));
  else run(document);
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
